import React, { useState } from "react";
import "./style.css"; // Importando o arquivo CSS
import { BiSolidRightArrow, BiSolidDownArrow } from "react-icons/bi";

const Archetype = ({ url, name, textHeader, textContent }) => {
  const [expanded, setExpanded] = useState(false);

  const handleExpand = () => {
    setExpanded(!expanded);
  };

  return (
    <div className="expandable-block" onClick={handleExpand}>
      <img src={url} alt={name} />
      <div onClick={handleExpand} className="name">
        {expanded ? <BiSolidDownArrow /> : <BiSolidRightArrow />}
        <h5>{name}</h5>
      </div>
      {expanded && (
        <div className="expanded-content">
          <p className="text-header">{textHeader}</p>
          <ul>
            {textContent.map((line, index) => {
              // Ignora linhas vazias
              if (line.trim() === "") return null;
              return <li key={index}>{line.trim()}</li>;
            })}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Archetype;
